import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from '@tanstack/react-router';
import type { JSX } from 'react';
import { Page, PageHeader } from '@/components/layout/page.js';
import { ErrorState } from '@/components/ui/error-state.js';
import { Skeleton } from '@/components/ui/skeleton.js';
import { queryKeys } from '@/lib/query/keys.js';
import { fetchCarrierRules } from './api.js';
import { CarrierRuleSheet } from './carrier-rule-sheet.js';

export function CarrierRulePage({ isNew = false }: { isNew?: boolean }): JSX.Element {
  const params: { id?: string } = useParams({ strict: false });
  const navigate = useNavigate();
  const query = useQuery({ queryKey: queryKeys.carriers.rules(), queryFn: fetchCarrierRules, enabled: !isNew });
  const rule = isNew ? null : query.data?.items.find((item) => item.id === params.id);
  if (!isNew && query.isPending) return <Page width="form"><Skeleton className="h-80 w-full" /></Page>;
  if (!isNew && (query.isError || !rule)) return <Page width="form"><ErrorState message="Règle transporteur introuvable." /></Page>;
  return <Page width="form">
    <PageHeader title={rule?.name ?? 'Nouvelle règle transporteur'} backLink={{ label: 'Retour aux transporteurs', to: '/transporteurs', search: { tab: 'regles' } }} />
    <CarrierRuleSheet inline open onOpenChange={(open) => { if (!open) void navigate({ to: '/transporteurs', search: { tab: 'regles' } }); }} rule={rule ?? null} />
  </Page>;
}
